<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>
<style lang="scss">
  html,
  body {
    margin: 0;
    height: 100%;

    #app {
      height: 100%;
      background: linear-gradient(180deg, #E7EFFE 0%, #FFFFFF 100%, #FFFFFF 100%);
    }
  }
</style>